import Img from "gatsby-image"
import React from "react"

export const ArticleImageSection: React.FC<{ src: any }> = ({ src }) => {
  if (!src) return null
  return (
    <React.Fragment>
      {/* <GatsbyImage
        className="bg-center bg-gray-400 bg-cover hidden lg:block shadow"
        image={src.childImageSharp.fluid}
        alt="coverImage"
      /> */}
      {/* <GatsbyImage
        className="bg-center bg-gray-400 bg-cover hidden lg:block shadow"
        image={src.childImageSharp.fluid}
        alt="coverImage"
      /> */}
      <Img
        className="bg-center bg-gray-400 bg-cover hidden lg:block shadow"
        style={{ height: 312 }}
        fluid={src.childImageSharp.fluid}
      />
      <Img
        className="bg-center bg-gray-400 bg-cover block lg:hidden"
        style={{ height: 256 }}
        fluid={src.childImageSharp.fluid}
      />
    </React.Fragment>
  )
}
